import styled from 'styled-components/native';

import Badge from 'components/Badge';

export default styled(Badge)`
  margin: 0 0 0 5px;
  background-color: #fc440f;
`;
